import NoData from "../../../../components/noData/noData";

/**
 * Auth Notes tab for the single-order layout (Sunstate Urology).
 *
 * Placeholder scaffold — renders an empty state until the Auth Notes
 * experience is built out.
 */
const AuthNotes = () => {
  return (
    <div className="auth-notes--container flex h-full flex-col gap-2">
      <div className="flex h-full items-center justify-center rounded-lg bg-gray-50">
        <NoData />
      </div>
    </div>
  );
};

export default AuthNotes;
